export default "__VITE_ASSET__yhP_n5pW__"